module.exports = __webpack_public_path__ + "img/37.4f1750ff.jpg";